import { pageViewTypes } from "@constants/tracking";
/* -----------------Types--------------- */
import AccountSettings from "@features/account/screens/AccountSettings";
import useAnalytics from "@hooks/useAnalytics";
import DocumentTitle from "components/DocumentTitle";
const AccountSettingsRoute = () => {
	useAnalytics({
		type: pageViewTypes.settings,
	});
	return (
		<>
			<DocumentTitle title="Account Settings" />
			<AccountSettings />
		</>
	);
};

export default AccountSettingsRoute;
